export function GooeyThinkingDots() {
  return (
    <svg
      width={52}
      height={20}
      style={{ overflow: 'visible', display: 'inline-block', verticalAlign: 'middle' }}
    >
      <defs>
        <filter id="neon-glow-dots" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="2.5" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      {([0, 1, 2] as const).map((i) => (
        <circle key={i} cx={10 + i * 16} cy={10} r={7} fill="#FF00FF" filter="url(#neon-glow-dots)">
          <animate
            attributeName="cy"
            values="10;3;10"
            dur="0.9s"
            repeatCount="indefinite"
            begin={`${i * 0.18}s`}
            calcMode="spline"
            keySplines="0.4 0 0.2 1;0.4 0 0.2 1"
          />
          <animate
            attributeName="fill"
            values="#FF00FF;#00FFFF;#FF00FF"
            dur="0.9s"
            repeatCount="indefinite"
            begin={`${i * 0.18}s`}
          />
        </circle>
      ))}
    </svg>
  );
}
